import { combineReducers } from '@reduxjs/toolkit'
import { authSliceReducer } from './authentication/authSlice'
import { bannersReducer } from './banners/bannersSlice'
import { cardinalityReducer } from './cardinality/cardinalitySlice'
import { clubManagersReducer } from './clubManagers/clubManagersSlice'
import { customBannersReducer } from './customBanners/customBannersSlice'
import { dailyReportReducer } from './dailyReport/dailyReportSlice'
import { extraMenuItemsReducer } from './extraMenuItems/extraMenuItemsSlice'
import { homeSliceReducer } from './home/homeSlice'
import { liveEventsReducer } from './liveEvents/liveEventsSlice'
import { matchesReducer } from './matches/matchesSlice'
import { membershipCodesReducer } from './membershipCodes/membershipCodesSlice'
import { messagesReducer } from './messages/messagesSlice'
import { playersRequestsReducer } from './playersRequests/playersRequestsSlice'
import { reportsReducer } from './reports/reportsSlice'
import { tweReducer } from './twe/tweSlice'
import { updateTasksReducer } from './updateTasks/updateTaskSlice'
import { usersReducer } from './users/usersSlice'

const rootReducer = combineReducers({
  authentication: authSliceReducer,
  clubManagers: clubManagersReducer,
  matches: matchesReducer,
  users: usersReducer,
  update_tasks: updateTasksReducer,
  customBanners: customBannersReducer,
  membershipCodes: membershipCodesReducer,
  banners: bannersReducer,
  reports: reportsReducer,
  cardinality: cardinalityReducer,
  playersRequests: playersRequestsReducer,
  homeRequests: homeSliceReducer,
  messages: messagesReducer,
  twe: tweReducer,
  dailyReport: dailyReportReducer,
  liveEvents: liveEventsReducer,
  extraMenuItems: extraMenuItemsReducer,
})

export default rootReducer
export type RootState = ReturnType<typeof rootReducer>
